import { Badge, Box, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

import { CAMPAIGN_ROUTE_TYPES } from '../../../../common/enums/enums';
import { NavLink } from 'react-router-dom';

const NameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const badgeColor = getEnumColor(CAMPAIGN_ROUTE_TYPES, rowData.type);
    const badgeLabel = getEnumLabel(CAMPAIGN_ROUTE_TYPES, rowData.type);
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Text>{rowData.name}</Text>
            <Badge
                color={badgeColor}
                size={'sm'}>
                {badgeLabel}
            </Badge>
        </Box>
    );
};

const NameColumn = () => ({
    accessorKey: 'name',
    header: 'Name',
    size: 1,
    Cell: ({ cell }) => <NameCell cell={cell} />,
});
export default NameColumn;
